import 'lazysizes'
import 'lazysizes/plugins/attrchange/ls.attrchange'

import { Box, Flex, Heading, Image, Table, Tbody, Td, Th, Thead, Tr } from '@chakra-ui/react'
import { chakra } from '@chakra-ui/system'
import Link from 'next/link'
import React from 'react'

import { MasterData } from '@/lib/UkiyoeData'

type Props = {
  data: MasterData
}

export const ListedAttributes = ({ data }: Props) => {
  const imageSize = '64px'
  const types = data.type
  const attributeKeys = Object.keys(data)
    .map((attribute) => attribute)
    .filter((attribute) => attribute !== 'type')

  return (
    <chakra.section mt="8">
      <Heading as="h1" mt="8" size="lg">
        Types and Attributes
      </Heading>

      <Box mt="8" overflowX="auto">
        <Heading as="h2" size="md">
          Ukiyoe Types
        </Heading>
        <Table mt="4" variant="simple" size="md">
          <Thead>
            <Tr>
              <Th>Attribute</Th>
              <Th isNumeric>#</Th>
              <Th>Examples</Th>
            </Tr>
          </Thead>
          <Tbody>
            {Object.keys(types).map((type, idx) => {
              return (
                <Tr key={idx}>
                  <Td>
                    <Link href={`/attributes/type/${type}`} prefetch={false}>
                      <a>
                        <chakra.span
                          color="#f79128"
                          cursor="pointer"
                          fontWeight="bold"
                          _hover={{ color: '#d95764' }}
                        >
                          {type}
                        </chakra.span>
                      </a>
                    </Link>
                  </Td>
                  <Td isNumeric>{types[type].count}</Td>
                  <Td>
                    <Flex>
                      {types[type].ids?.slice(0, 1).map((id) => {
                        return (
                          <Link key={id} href={`/details/${id}`} prefetch={false}>
                            <a>
                              <Image
                                bg="#677f75"
                                fit="contain"
                                className="lazyload pixelated"
                                w={imageSize}
                                h={imageSize}
                                htmlWidth={imageSize}
                                htmlHeight={imageSize}
                                data-src={`/images/ukiyoe/b/${id}.png`}
                                fallbackSrc="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAYAAAAfFcSJAAAADUlEQVR42mNMry/9DwAFDAJc2KCJiQAAAABJRU5ErkJggg=="
                                alt={id.toString()}
                              />
                            </a>
                          </Link>
                        )
                      })}
                    </Flex>
                  </Td>
                </Tr>
              )
            })}
          </Tbody>
        </Table>
      </Box>

      {attributeKeys.map((attributeKey) => {
        return (
          <Box key={attributeKey} mt="8" overflowX="auto">
            <Heading as="h2" size="md">
              {attributeKey.toUpperCase()}
            </Heading>
            <Table mt="4" variant="simple" size="md">
              <Thead>
                <Tr>
                  <Th>Attribute</Th>
                  <Th isNumeric>#</Th>
                  <Th>Examples</Th>
                </Tr>
              </Thead>
              <Tbody>
                {Object.keys(data[attributeKey]).map((name, idx) => {
                  const attribute = data[attributeKey][name]

                  return (
                    <Tr key={idx}>
                      <Td>
                        <Link href={`/attributes/${attributeKey}/${name}`} prefetch={false}>
                          <a>
                            <chakra.span
                              color="#f79128"
                              cursor="pointer"
                              fontWeight="bold"
                              _hover={{ color: '#d95764' }}
                            >
                              {name}
                            </chakra.span>
                          </a>
                        </Link>
                      </Td>
                      <Td isNumeric>{attribute.count}</Td>
                      <Td>
                        <Flex>
                          {attribute.ids?.slice(0, 1).map((id) => {
                            return (
                              <Link key={id} href={`/details/${id}`} prefetch={false}>
                                <a>
                                  <Image
                                    bg="#677f75"
                                    fit="contain"
                                    className="lazyload pixelated"
                                    w={imageSize}
                                    h={imageSize}
                                    htmlWidth={imageSize}
                                    htmlHeight={imageSize}
                                    data-src={`/images/ukiyoe/b/${id}.png`}
                                    fallbackSrc="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAYAAAAfFcSJAAAADUlEQVR42mNMry/9DwAFDAJc2KCJiQAAAABJRU5ErkJggg=="
                                    alt={id.toString()}
                                  />
                                </a>
                              </Link>
                            )
                          })}
                        </Flex>
                      </Td>
                    </Tr>
                  )
                })}
              </Tbody>
            </Table>
          </Box>
        )
      })}
    </chakra.section>
  )
}
